import { useCallback } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import TrackPage from '../../components/TrackPage/TrackPage';
// @ts-expect-error Could not find a declaration file for module
import TrackDeprecatedModal from '../../components/Modals/FeatureIntroModals/TrackDeprecatedModal';
import { isTrackDeprecated } from '../../utils/utils';
import { getNextContentUrl } from '../../features/tracks/tracksRouting';
import { usePlaylistIdFromSearch } from '../../features/playlistContent/hooks';
import { useLessonPreQuizSession } from '../../features/preAssessmentQuiz/hooks/useLessonPreQuiz';
import { getFocusContentId, isPreAssessmentCompleted } from '../../features/preAssessmentQuiz/utils/preAssessmentQuizUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackPageContainer = ({
  track,
  trackProgress,
  lesson,
  content,
  contentFragment,
  contentProgress,
  lessonProgress
}) => {
  const {
    push,
    location
  } = useHistory();
  const isInPlaylist = !!usePlaylistIdFromSearch();
  const {
    getLessonPreQuizState
  } = useLessonPreQuizSession();
  const handleAdvanceContent = useCallback(() => {
    if (!content || !lesson) {
      return;
    }
    push(Object.assign({}, location, {
      pathname: getNextContentUrl({
        track,
        lesson,
        contentId: content.id,
        isInPlaylist,
        getLessonPreQuizState
      })
    }));
  }, [content, lesson, track, isInPlaylist, location, getLessonPreQuizState, push]);
  const handleSkipPreAssessment = useCallback(() => lesson ? push(Object.assign({}, location, {
    pathname: `/tracks/${track.id}/${lesson.id}`
  })) : push(Object.assign({}, location, {
    pathname: `/tracks/${track.id}`
  })), [location, track, lesson, push]);
  const handleStartLessonWithPreAssessmentFocus = useCallback(() => {
    if (lesson) {
      const preQuizState = getLessonPreQuizState(lesson.id);
      if (preQuizState && isPreAssessmentCompleted(preQuizState)) {
        const firstFocusId = getFocusContentId({
          lessonContent: lesson.content,
          perContentScores: preQuizState.perContentScores
        });
        if (firstFocusId) {
          push(Object.assign({}, location, {
            pathname: `/tracks/${track.id}/${lesson.id}/${firstFocusId}`
          }));
          return;
        }
      }
      push(Object.assign({}, location, {
        pathname: `/tracks/${track.id}/${lesson.id}`
      }));
    }
  }, [push, location, track, lesson, getLessonPreQuizState]);
  const isDeprecated = isTrackDeprecated(track.deprecated, track.deprecationFinalDate);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "COURSE_VIEW_LOADED",
    children: [/*#__PURE__*/_jsx(TrackPage, {
      content: content,
      contentFragment: contentFragment,
      contentProgress: contentProgress,
      lesson: lesson,
      lessonProgress: lessonProgress,
      onAdvanceContent: handleAdvanceContent,
      onSkipPreAssessment: handleSkipPreAssessment,
      onStartLessonWithPreAssessmentFocus: handleStartLessonWithPreAssessmentFocus,
      track: track,
      trackProgress: trackProgress
    }), isDeprecated && /*#__PURE__*/_jsx(TrackDeprecatedModal, {
      cta: track.deprecationCta,
      message: track.deprecationMessage,
      trackId: track.id
    })]
  });
};
export default TrackPageContainer;